import { render, staticRenderFns } from "./ruleAd.vue?vue&type=template&id=f104d106&scoped=true"
import script from "./ruleAd.vue?vue&type=script&lang=js"
export * from "./ruleAd.vue?vue&type=script&lang=js"
import style0 from "./ruleAd.vue?vue&type=style&index=0&id=f104d106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f104d106",
  null
  
)

export default component.exports